<template>
  <div>
    <search-list
    :projectList="projectList"
    :typeList="typeList"
    @searchParams="search"
    :inline="true"

    ></search-list>
    <div style="padding-top: 0;margin-left:26px;">
      <Button v-p="{api:'businessScore/exportBusinessScoreList'}" type="primary" :loading = "btnLoading" @click="exportFile()" class="mb16">导出</Button>
    </div>
    <table-list
      class="page-wrapper"
      style="padding-top:0"
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    >
    </table-list>
  </div>
</template>

<script>

import SearchList from './components/SearchList'
import TableList from 'components/TableList/index';
import { getProjects } from 'api/common'
import {findBusinessScoreList,exportBusinessScoreList} from 'api/businessDealApi'
import {formatDateTime} from "../../../../../utils/format"

export default {
  name:'businessDeal',
  components:{
    SearchList,
    TableList,
  },
  data(){
    return{
      btnLoading:false,
      addN:0,
      current:1,
      total:0,
      loading:false,
      projectList:[],
      limit:10,
      page:1,
      data:[],
      typeList:[
				{
					text:'接录商机',
					value:'s301'
				},
				{
					text:'带看',
					value:'s302'
				},
				{
					text:'新签',
					value:'s303'
				},
				{
					text:'续约',
					value:'s304'
				},
			],
      columns:[
        {
          title:'项目名称',
          key: 'projectName',
          width: 200,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'商机标识',
          key: 'businessPhone',
          width: 120,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'处理人',
          key: 'handleZoName',
          width: 100,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'处理类别',
          key: 'typeName',
          width: 100,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'计分',
          key: 'score',
          width: 100,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'处理时间',
          key: 'handleDate',
          width: 200,
          align: 'center',
          render:(h,params)=>{
            return h('span',{},this.format(params.row['handleDate']))
          }
        },
        {
          title: ' '
        },
        {
          title:'备注',
          key: 'remark',
          width: 160,
          align: 'center'
        },
        {
          title: ' '
        },
      ]
    }
  },
  created(){
    this.getProjectsData();
  },
  methods:{
    exportFile(){
      let data = {};
        for (let key in this.searchParams) {
          if(key==='page' || key==='limit') continue;
          data[key] = this.searchParams[key]
        }
        this.btnLoading = true;
        exportBusinessScoreList(data).then( res => {
          if(res.headers.count > 10000){
            this.btnLoading = false;
            this.$Modal.info({
              title: '导出合同',
              content:'上限10000条，请选择条件后下载'
            });
          } else{
            let filename = res.headers.filename || 'excel.xls';
            let blob = new Blob([res.data]);
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            this.btnLoading = false
          }
        }).catch( err => {
          this.btnLoading = false;
          console.log(err)
        })
    },
    search(data){
      this.searchParams = data
      this.page=1
      this.current=1
      this.getSearchData();
    },
    getSearchData(){
      let params= {
        ...this.searchParams,
        page:this.page,
        limit:this.limit
      }
			findBusinessScoreList(params)
			.then( res => {
        this.data = res.data.rows;
        this.total = res.data.total;
        this.data.forEach( ele => {
          switch (ele.typeCode){
            case 's301':
              ele.typeName = '接录商机';
              break;
            case 's302':
              ele.typeName = '带看'
              break;
            case 's303':
              ele.typeName = '新签'
              break
            case 's304':
              ele.typeName = '续约'
              break
            default:
              ele.typeName = ''
          }
        })
			})
		},
    getProjectsData(){
      getProjects()
      .then(res => {
        this.projectList = res.data;
      })
    },
    changPage(n){
      this.current = n;
      this.page = n;
      this.getSearchData()
    },
    format(data, showTime = true) {
      if (!data) {
        return ''
      }
      return formatDateTime(data, showTime)
    }
  }
}
</script>

<style>

</style>
